import { render, staticRenderFns } from "./ProductInfoItemName.vue?vue&type=template&id=ffa03d80&scoped=true&"
import script from "./ProductInfoItemName.vue?vue&type=script&lang=js&"
export * from "./ProductInfoItemName.vue?vue&type=script&lang=js&"
import style0 from "./ProductInfoItemName.vue?vue&type=style&index=0&id=ffa03d80&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffa03d80",
  null
  
)

export default component.exports